import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthPayxService } from 'src/app/services/payx/authPayx.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-fg-password',
  templateUrl: './fg-password.component.html',
  styleUrls: ['./fg-password.component.scss']
})
export class FgPasswordComponent implements OnInit {

  toggle:boolean=false;
  codeToggle:boolean=false;
  loading:boolean=false;
  phone:string='';
  code:string='';
  successToggle:boolean=false;
  message:string="You password is changeing successfully"
  showerror: boolean = false
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  password: FormGroup
  constructor(private _formBuilder: FormBuilder,private resetService:AuthPayxService, private router:Router) { }

  ngOnInit() {
    // this.click();
    this.firstFormGroup = this._formBuilder.group({
      phone: ['', Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required],
    });
    this.password = this._formBuilder.group({
      newPass: ['', Validators.required],
      confPass: ['', Validators.required]
    })
  }

  // private click(){
  //   this.toggle=!this.toggle;
  //   let f=document.getElementsByClassName('front')[0] as HTMLElement;
  //   let b=document.getElementsByClassName('back')[0] as HTMLElement;
  //   f.classList.toggle('front-transform')
  //   b.classList.toggle('back-transform')
  // }

  snedResetCode(){
    // if(this.codeToggle){
    //   this.onCodeCompleted(this.code);
    //   return
    // }
    if(this.firstFormGroup.get('phone').value.toString() == '' || this.firstFormGroup.get('phone').value.toString() == null || this.firstFormGroup.get('phone').value.toString() == undefined
    || this.firstFormGroup.get('phone').value.toString().length < 6)
    return
    // return
    this.loading=true;
    this.resetService.sendCode(this.firstFormGroup.get('phone').value.toString()).subscribe(
      res=>{
        this.loading=false;
      },
      err=>{
        this.loading=false;
      }

    )
  }


  onCodeCompleted(event){
    this.showerror = false
    // document.getElementById('codebtn').click()
    this.resetService.validateRes(this.firstFormGroup.get('phone').value.toString(),event).subscribe(
      res=>{
        this.secondFormGroup.get("secondCtrl").setValue(event.toString())
        document.getElementById('codebtn').click()
      },
      err=>{
        this.showerror = true
      }
    )
  }
  onCodeChanged(event){
    this.code=event;
  }

  changePassword(){
    if(this.password.get('newPass').value.toString() != this.password.get('confPass').value.toString())
      return;
    this.resetService.resetPassword(this.firstFormGroup.get('phone').value.toString(), this.password.get('newPass').value.toString()).subscribe(
      res=>{
        this.successToggle=true;
      }
    )

  }

  okClick(){
    this.router.navigateByUrl('');
  }

  goBack()
  {
    this.router.navigateByUrl('payx-login')
  }

}
